import React, { useState, useEffect } from "react";
import MetaTags from "react-meta-tags";
import PropTypes from "prop-types";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  Alert,
  Label,
  Row,
} from "reactstrap";

import Select from "react-select";
import SweetAlert from "react-bootstrap-sweetalert";

// Redux
import { connect, useSelector, useDispatch } from "react-redux";
import { withRouter, Link, useHistory } from "react-router-dom";

//Import Breadcrumb
import Breadcrumb from "../../components/Common/Breadcrumb";
import Loader from "../../components/Common/Loader";

//actions
import { comprasCreate } from "../../store/compras/actions";
import { contactsFulllist } from "../../store/contacts/actions";

const ComprasAdd = (props) => {
  const history = useHistory();

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(contactsFulllist());
  }, [dispatch]);

  const contact = useSelector((state) => state.Contacts.contacts) || [];

  const [cotizacion, setFormDataCotizacion] = useState([]);

  const handleCotizacionChange = (evCotizacion) => {
    Array.from(evCotizacion).forEach((cotizacion) => {
      var reader = new FileReader();
      reader.readAsDataURL(cotizacion);
      reader.onload = function () {
        var img = [];
        var base64 = reader.result;
        img = base64.split(",");
        setFormDataCotizacion(img[1]);
      };
    });
  };
  const [prefacturacion, setFormDataPrefacturacion] = useState([]);

  const handlePrefacturacionChange = (evCotizacion) => {
    Array.from(evCotizacion).forEach((prefacturacion) => {
      var reader = new FileReader();
      reader.readAsDataURL(prefacturacion);
      reader.onload = function () {
        var img = [];
        var base64 = reader.result;
        img = base64.split(",");
        setFormDataPrefacturacion(img[1]);
      };
    });
  };

  const [selectedCliente, setSelelectedCliente] = useState(null);
  const [selectedProveedor, setSelelectedProveedor] = useState(null);
  const Cliente = selectedCliente;
  const Proveedor = selectedProveedor;
  function handleSelectProveedor(selectedProveedor) {
    setSelelectedProveedor(selectedProveedor.value);
  }

  function handleSelectCliente(selectedCliente) {
    setSelelectedCliente(selectedCliente.value);
  }

  const [formData, setFormData] = useState({
    valor_pagar: "",
  });

  const { valor_pagar } = formData;

  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const [selectedIva, setSelectedIva] = useState(null);

  function handleSelectIva(selectedIva) {
    setSelectedIva(selectedIva.value);
  }
  const [selectedFORMA_PAGO, setSelectedFORMA_PAGO] = useState(null);

  function handleSelectFORMA_PAGO(selectedFORMA_PAGO) {
    setSelectedFORMA_PAGO(selectedFORMA_PAGO.value);
  }

  const onSubmit = (e) => {
    e.preventDefault();
    props.comprasCreate({
      adjuntar_cotizacion: cotizacion,
      Cliente,
      Proveedor,
      valor_pagar,
      prefacturacion,
      iva:selectedIva,
      forma_pago:selectedFORMA_PAGO
    });
  };

  const redirect = () => {
    history.push("/compras");
  };


  const IVA = [
    {
      options: [
        { label: "INCLUIDO", value: "incluido" },
        { label: "EXENTO", value: "exento" },
      
      ],
    },
  ];

  
  const FORMA_PAGO = [
    {
      options: [
        { label: "EFECTIVO", value: "efectivo" },
        { label: "CREDITO", value: "credito" },
        { label: "ANTICIPO", value: "anticipo" },
      ],
    },
  ];

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>TCCONTROL| COMPRAS </title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumb title={"TCCONTROL"} breadcrumbItem={"COMPRAS"} />
          {props.loading ? (
            <Loader />
          ) : (
            <Card className="col-lg-8 mx-auto  mt-3">
              {props.comprasCreated.id ? (
                <SweetAlert
                  title="Hecho!"
                  success
                  timeout={2000}
                  showConfirm={false}
                  onConfirm={() => {
                    redirect();
                  }}
                >
                  Se ha agregado la COMPRAS con éxito
                </SweetAlert>
              ) : null}
              <CardBody>
                <h4 className="card-title">AGREGAR COMPRAS</h4>
                <Form className="needs-validation" onSubmit={onSubmit}>
                  <Row className="col-lg-12 justify-content-center mt-3">
                    <Col md={6} className="mb-3">
                      <Label
                        for="name"
                        className="col-form-label col-sm-4 d-flex"
                      >
                        <strong>CLIENTE</strong>
                      </Label>

                      <Select
                        id="accountlist"
                        name="accountlist"
                        placeholder="Seleccione"
                        onChange={handleSelectCliente}
                        options={
                          contact &&
                          contact.map((item) => ({
                            label: item.first_name
                              ? item.first_name
                              : item.razon_social,
                            value: item.id,
                          }))
                        }
                      />
                    </Col>

                    <Col md={6} className="mb-3">
                      <Label
                        for="name"
                        className="col-form-label col-sm-4 d-flex"
                      >
                        <strong>PROVEEDOR</strong>
                      </Label>

                      <Select
                        id="accountlist"
                        name="accountlist"
                        placeholder="Seleccione"
                        onChange={handleSelectProveedor}
                        options={
                          contact &&
                          contact.map((item) => ({
                            label: item.first_name
                              ? item.first_name
                              : item.razon_social,
                            value: item.id,
                          }))
                        }
                      />
                    </Col>
                  </Row>

                  <Row className="col-lg-12 justify-content-center mt-3">
                    <Col md={6} className="mb-3">
                      <Label
                        for="image_file"
                        className="col-form-label col-sm-8 d-flex"
                      >
                        <strong>COTIZACION (OPCIONAL)</strong>
                      </Label>

                      <input
                        className="form-control"
                        id="image_file"
                        name="image_file"
                        type="file"
                        multiple={false}
                        onChange={(e) =>
                          handlePrefacturacionChange(e.target.files)
                        }
                      />
                    </Col>

                    <Col md={6} className="mb-3">
                      <Label
                        for="image_file"
                        className="col-form-label col-sm-8 d-flex"
                      >
                        <strong>PRE-FACTURACION (OPCIONAL)</strong>
                      </Label>

                      <input
                        className="form-control"
                        id="image_file"
                        name="image_file"
                        type="file"
                        multiple={false}
                        onChange={(e) => handleCotizacionChange(e.target.files)}
                      />
                    </Col>
                  </Row>

                  <Row className="col-lg-12 justify-content-center mt-3">
                    <Col md={6} className="mb-3">
                      <Label
                        for="valor_pagar"
                        className="col-form-label col-sm-8 d-flex"
                      >
                        <strong>VALOR A A PAGAR </strong>
                      </Label>

                      <input
                        className="form-control"
                        id="valor_pagar"
                        name="valor_pagar"
                        type="text"
                        onChange={onChange}
                      />
                      {props.error && props.error.valor_pagar ? (
                        <Alert color="danger" className="mt-2">
                          {props.error.valor_pagar}
                        </Alert>
                      ) : null}
                    </Col>
                    <Col md={6} className="mb-3">
                      <Label for="tipo_visita" className="form-label mt-2">
                        <strong>Tipo de Servicio</strong>
                      </Label>
                      <Select
                        id="tipo_servicio"
                        name="tipo_servicio"
                        options={IVA}
                        onChange={handleSelectIva}
                        autoFocus
                      />
                    </Col>
                  </Row>

                  <Row className="col-lg-12 justify-content-center mt-3">
                    <Col md={6} className="mb-3">
                      <Label for="tipo_visita" className="form-label mt-2">
                        <strong>FORMA DE PAGO</strong>
                      </Label>
                      <Select
                        id="tipo_servicio"
                        name="tipo_servicio"
                        options={FORMA_PAGO}
                        onChange={handleSelectFORMA_PAGO}
                        autoFocus
                      />
                    </Col>

                    <Col md={6} className="mb-3">
                      <Label
                        for="valor_pagar"
                        className="col-form-label col-sm-8 d-flex"
                      >
                        <strong>OBSERVACIONES</strong>
                      </Label>

                      <input
                        className="form-control"
                        id="valor_pagar"
                        name="valor_pagar"
                        type="text"
                        onChange={onChange}
                      />
                    </Col>
                  </Row>
                  <Row className="col-lg-12 justify-content-center mt-3"></Row>

                  <Row className=" mx-2 col-lg-12 justify-content-center">
                    <Col md={4} className="m-1">
                      <Link
                        className="btn btn-secondary text-dark"
                        to="/compras"
                      >
                        VOLVER
                      </Link>

                      <Button color="primary" type="submit" className="ms-1">
                        AGREGAR
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </CardBody>
            </Card>
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  const { error, loading, comprasCreated } = state.Compras;
  return { error, loading, comprasCreated };
};

ComprasAdd.propTypes = {
  error: PropTypes.any,
  loading: PropTypes.bool,
  comprasCreated: PropTypes.object,
};
export default withRouter(
  connect(mapStateToProps, { comprasCreate })(ComprasAdd)
);
